var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webhook-data-item" },
    [
      _c("CustomPicker", {
        staticStyle: { width: "250px" },
        attrs: {
          items: _vm.properties,
          idKey: "id",
          labelKey: "label",
          title: _vm.$t("message.selectField"),
        },
        model: {
          value: _vm.clone.field,
          callback: function ($$v) {
            _vm.$set(_vm.clone, "field", $$v)
          },
          expression: "clone.field",
        },
      }),
      _vm._v(" "),
      _c("TiptapEditor", {
        attrs: {
          placeholder: "Value",
          "show-attributes": true,
          "automation-mode": "",
        },
        model: {
          value: _vm.clone.value,
          callback: function ($$v) {
            _vm.$set(_vm.clone, "value", $$v)
          },
          expression: "clone.value",
        },
      }),
      _vm._v(" "),
      _vm.isDeleteButtonVisible
        ? _c(
            "SupsisButton",
            { attrs: { small: "", danger: "" }, on: { click: _vm.deleteItem } },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }